import React, { useState, useEffect, useCallback } from 'react';
import { Button, message } from 'antd';
import { withRouter } from 'react-router-dom';
import goto from '@/common/goto';
import SingleHeader from './../../daily-activities-details-manager/material-pool-manage/components/single-header';
import { requestFormPost, requestGet } from '@/common/request';
import { getQuery } from '@/common/utils';

import './index.less';

/*****************
 * 门槛规则 *
 *****************/

const MaterialPoolRule = withRouter((props) => {
  const [ruleRes, setRuleRes] = useState({});
  const [ruleList, setRuleList] = useState([]);
  const [ruleId, setRuleId] = useState('');
  const [isAssgined, setIsAssgined] = useState(false);
  const [isDaily, setIsDaily] = useState(location.pathname.startsWith('/activity-manage'));
  const { channelId } = props.match.params;
  const memoizedFetchData = useCallback(async () => {
    const blockId = getQuery('blockId');
    const {
      ret,
      msg,
      data: { ruleContent, ruleId },
    } = await requestGet(`/generic/mac/common/query/ruleset?resourceId=${blockId}&resourceType=2`);

    if (ret === '0') {
      if (ruleContent.length) {
        setRuleList(ruleContent);
        setRuleId(ruleId);
      } else {
        setRuleList([]);
      }
    } else {
      message.error(`${msg || '获取门槛规则异常,请您稍后重试！'}`);
    }
  }, []);
  useEffect(() => {
    async function fetchData() {
      const blockId = getQuery('blockId');
      const { ret, data } = await requestGet(`/generic/mac/area/isAssigned?areaId=${blockId}&resourceType=2`);
      if (ret === '0') {
        setIsAssgined(data.data);
      }
    }
    fetchData();
  }, []);
  useEffect(() => {
    memoizedFetchData();
  }, [memoizedFetchData]);

  // 设置规则
  function newBuildRule() {
    if (!isDaily) {
      goto
        .materialPoolRuleNew(
          getQuery('channelId'),
          '',
          ruleId || '',
          `&activityId=${getQuery('activityId')}&blockId=${getQuery('blockId')}&resourceId=${
            getQuery('resourceId') || ''
          }&from=block&status=${isAssgined ? 'disabled' : 'new'}`
        )
        .newTab();
    } else {
      goto
        .dailyPoolRule(
          `activityId=${getQuery('activityId')}&blockId=${getQuery('blockId')}&resourceId=${
            getQuery('resourceId') || ''
          }&ruleId=${ruleId || ''}&from=block&status=${isAssgined ? 'disabled' : 'new'}`
        )
        .newTab();
    }
  }

  return (
    <div className="material-pool-rule-wrapper">
      <div className="pool-rule-h1">
        <img
          src="//img30.360buyimg.com/pop/jfs/t1/88290/21/20454/1228/6230355aEa70e53ee/b371653f50852db0.png"
          width={70}
          height={70}
          style={{ marginRight: 12 }}
        />
        <SingleHeader
          title="邀约门槛规则"
          hoverText="邀约门槛规则：资源位的基础红线规则，符合门槛规则的商品、店铺等素材才能进行运营展示"
          large
        />
      </div>
      <div className="pool-rule-list-fa">
        <div className="pool-rule-list">
          {ruleList && Array.isArray(ruleList) && ruleList.length > 0 ? (
            ruleList.map((item, index) => {
              return (
                <div className="pool-rule-item" key={index}>
                  <span className="pool-rule-item-icon"></span>
                  <span title={item} className="pool-rule-item-txt">
                    {item}
                  </span>
                </div>
              );
            })
          ) : (
            <div className={!isAssgined ? 'unset un-allocating' : 'unset'}>
              {!isAssgined ? (
                <span style={{ marginRight: 14 }}>请基于该门槛规则设置邀约门槛规则，分配后下级将在此之上选品</span>
              ) : (
                <span>您未配置邀约规则，分配后下级将基于该门槛规则进行选品邀约</span>
              )}
              {!isAssgined && (
                <Button onClick={() => newBuildRule()} type="primary">
                  去设置
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
      {ruleList && !!ruleList.length && (
        <div className="pool-rule-btn">
          <Button type="primary" shape="round" onClick={() => newBuildRule()}>
            {isAssgined ? '查看规则' : '设置规则'}
          </Button>
        </div>
      )}
    </div>
  );
});

export default MaterialPoolRule;
